<template>
  <div>
    <div class="f-c" v-if="isPC">
      <div class="content f">
        <NewTime @selectTime="selectTime" class="bg-white time-filter"/>
        <div style="padding: 0 0 0 280px;">
          <div class="banner-head">
            <img src="https://img.kakaclo.com/web-img/index/new_in1.jpg" alt="" lazy />
          </div>
          <CommodityList :time="timeLine" />
        </div>
      </div>
    </div>
    <div v-else class="mobile-newin bg-white">
      <oss-img src="https://img.kakaclo.com/web-img/index/new_in1.jpg" :width="172" style="width:100%" :height="23"></oss-img>
      <CommodityList />
    </div>
  </div>
</template>

<script>
import NewTime from '@/views/commodity/components/NewTime.vue'
import CommodityList from '@/views/commodity/components/CommodityList.vue'
export default {
  components: {
    NewTime,
    CommodityList
  },
  data() {
    return {
      timeLine: undefined
    }
  },
  created() {
  },
  methods: {
    selectTime(data) {
      this.timeLine = data
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  max-width: 1400px;
  min-width: 1000px;
  padding: 0 15px;
}
.banner-head {
  max-width: 1380px;
  border-radius: 12px;
  padding: 30px 0 5px 0;
  padding-right: 16px;
  img {
    width: 100%;
    border-radius: 12px;
    object-fit: contain;
  }
}
.mobile-newin{
  padding: 0.2rem 0.3rem;
  min-height: calc(100vh - 0.9rem);
}
.time-filter{
    position: fixed;
    bottom: 0;
    left: calc((100vw - 1400px) / 2);
}
@media screen and (min-width:1000px) and(max-width: 1400px ) {
  .time-filter{
    left: 15px!important;
  }
}
</style>
